export default {
    SET_RESALES: (state, resales) => {
        state.items = resales;
    },

    SET_DEALER: (state, value) => {
        state.dealer = value;
    },

    SET_BRAND_ID: (state, value) => {
        state.brandId = value;
    },

    SET_OPTION: (state, value) => {
        state.option = value;
    },

    CREATE_RESALE: (state, resale) => {
        state.items.unshift(resale);
    },

    UPDATE_RESALE: (state, resale) => {
        const updateIndex = state.items.findIndex(it => it.id === resale.id);

        state.items.splice(updateIndex, 1, resale);
    },

    REMOVE_RESALE: (state, id) => {
        const removeIndex = state.items.findIndex(it => it.id === id);

        state.items.splice(removeIndex, 1);
    }
};
